import React, { useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { RadioGroup } from '@mui/material'
import RadioButtonWithLabel from '../partials/RadioButtonWithLabel'
import { useFormContext } from 'react-hook-form'

const useStyles = makeStyles()(() => ({
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
}))

/*
ラジオボタンでbool値をセットできるコンポーネント
 */
const SwitchRadioButton: React.FC<{
  name: string
  trueLabel: string
  falseLabel: string
}> = ({ name, trueLabel, falseLabel }) => {
  const { classes } = useStyles()
  const { setValue, getValues } = useFormContext()

  const [result, setResult] = useState(getValues(name) ? '1' : '0')
  useEffect(() => {
    switch (result) {
      case '0':
        setValue(name, false)
        break
      case '1':
        setValue(name, true)
        break
      default:
        setValue(name, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result])

  return (
    <RadioGroup
      className={classes.radioGroup}
      value={result}
      onChange={(event) => setResult(event.target.value)}
    >
      <RadioButtonWithLabel value={'0'} label={falseLabel} />
      <RadioButtonWithLabel value={'1'} label={trueLabel} />
    </RadioGroup>
  )
}

export default SwitchRadioButton
